import { IDocumentItemProps } from "../../../../interfaces/Ui/Documents/DocumentsItemUI/IDocumentsItemProps";
import classes from "./DocumentItemUI.module.css";
import React from "react";

export const DocumentItemUI = ({
  className,
  title,
  titleProps,
  subtitle,
  subtitleProps,
  children,
  documentInfoContainerProps,
  ...containerProps
}: IDocumentItemProps) => {
  const concatContainerClassName = `${className} ${classes.document}`;
  const concatTitleClassName = `${
    titleProps?.className ? titleProps.className : ""
  } ${classes.documentTitle}`;
  const concatFileInfoClassName = `${
    subtitleProps?.className ? subtitleProps.className : ""
  } ${classes.documentFileInfo}`;

  const concatContainerDocumentInfo = `${
    documentInfoContainerProps?.className
      ? documentInfoContainerProps?.className
      : ""
  } ${classes.documentInfoContainer}`;

  return (
    <div {...containerProps} className={concatContainerClassName}>
      <div
        {...documentInfoContainerProps}
        className={concatContainerDocumentInfo}
      >
        <p {...titleProps} className={concatTitleClassName}>
          {title}
        </p>
        <p {...subtitleProps} className={concatFileInfoClassName}>
          {subtitle}
        </p>
      </div>

      {children}
    </div>
  );
};
